module.exports = __webpack_public_path__ + "static/media/SFProDisplay-Ultralight.7db578a4.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/SFPro/TrueType/SFProDisplay-Ultralight.ttf
// module id = 2537
// module chunks = 7